import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/ExcursionHallsTable.vue"),
          meta: { title: "Список залов", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create/:museumId",
          component: () => import("@/views/forms/ExcursionHallsForm.vue"),
          meta: { title: "Создать экскурсионный зал", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/ExcursionHallsForm.vue"),
          meta: {
            title: "Редактировать экскурсионный зал",
            activeMenuParent: true,
          },
          hidden: true,
        },
      ],
    },
  ];
};
